import { Search } from 'lucide-react';

import { Input, type InputProps } from '@platform/ui/components/input';
import { cn } from '@platform/ui/lib/utils';

export interface SearchInputProps extends Omit<InputProps, 'type'> {
    /** A search box carries no visible label; the icon and this name say what it is. */
    'aria-label': string;
}

/**
 * The box a list is searched with: a magnifier that says what it is, an
 * accessible name, and the placeholder left as an example of what to type
 * rather than the only label (docs/10 §4, Input). `className` sizes the wrapper.
 */
export function SearchInput({ className, ...props }: SearchInputProps) {
    return (
        <span data-slot="search-input" className={cn('relative inline-flex w-full', className)}>
            <Search aria-hidden="true" className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
            <Input type="search" {...props} className="pl-10" />
        </span>
    );
}
